module.exports = __webpack_public_path__ + "static/media/bongoLo.de2daa83.wav";